import React from 'react';
import { Marker } from '@Components/Marker';

const CustomMarker = ({ children }) => {
    if (!children) return;
    const truncateLinkText = str => {
        if (str.length > 80) {
            return str.substr(0, 20) + '...' + str.substr(str.length - 20, str.length);
        }
        return str;
    };

    return (
        <Marker
            linkDecorator={(decoratedHref, decoratedText, key) => {
                return (
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={decoratedHref}
                        key={key}
                        onClick={e => e.stopPropagation()}
                    >
                        {truncateLinkText(decoratedText)}
                    </a>
                );
            }}
        >
            <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{children}</div>
        </Marker>
    );
};

export { CustomMarker };
